module.exports = __webpack_public_path__ + "img/Lime-24-Blog-Banner1.c51d64c6.jpg";